import { Component, OnInit,Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppOfflineStore } from 'src/app/app.offlineService';
import { ExamManagementService } from 'src/app/Services/exam-management/exam-management.service';
import{QuestionManagementService} from '../../../Services/question-management/question-management.service';
import{SessionService}from'../../../Services/session.service';
@Component({
  selector: 'app-exam-instance-subject-wise-topics',
  templateUrl: './exam-instance-subject-wise-topics.component.html',
  styleUrls: ['./exam-instance-subject-wise-topics.component.css']
})
export class ExamInstanceSubjectWiseTopicsComponent implements OnInit {
  @Input() MajorTopic:MajorTopic[]=[];

  constructor(private toastr: ToastrService,public ExamService: ExamManagementService,private appserv:AppOfflineStore,public service:QuestionManagementService,public session:SessionService) {
    this.ExamService.getExamInstanceConcept({LoggedInUser:this.session.getUser(),CourseID:this.ExamService.ExamInstanceID,CourseConceptID:this.ExamService.ExamConceptID,SubjectId:this.ExamService.ExamSubjectID}).subscribe(
      res => { this.getExamInstanceConceptResponse(res) },
      error => { console.log(error) }
    )
    this.ExamService.getExamInstanceConceptSubject({LoggedInUser:this.session.getUser(),CourseSubjectID:this.ExamService.ExamInstanceSubjectID}).subscribe(
      res => { this.getExamInstanceConceptSubject(res) },
      error => { console.log(error) }
    )
  }

  ngOnInit(): void {
    // this.ExamService.getExamInstanceConcept({LoggedInUserID:this.session.getUser(),ExamInstanceID:this.ExamService.ExamInstanceID,Exam_Instance_Concept_Id:this.ExamService.ExamConceptID,Subject_Id:this.ExamService.ExamSubjectID}).subscribe(
    //   res => { this.getExamInstanceConceptResponse(res) },
    //   error => { console.log(error) }
    // )
    this.selectsubject(this.ExamService.ExamSubjectID);
    this.getDifficultLevelType();
    this.gettesttype();

  }
  selectedconceptlist:any;
  MinimumError:boolean=false;
  MaximumError:boolean=false;
  UpperError:boolean=false;
  LowerError:boolean=false;
  OpenAddEditConceptpopup(data:any){
    this.selectedconceptlist=data;
    this.AddEditConceptmodelpopup();



}
  getdifficultleveltype:any;
  responselevel:any
  getDifficultLevelType()
  {
    this.ExamService.GetCode({'Tablename':"DIFFICULTY_LEVEL_TYPE"}).subscribe((i:any)=>{
      this.getdifficultleveltype=i;
      this.getdifficultleveltype.forEach((element:any,index: any)=>{
        if(element.Code=='Unknown')
        this.getdifficultleveltype.splice(index,1);
     });
      console.log(this.getdifficultleveltype);
    // }).catch((e:any)=>{
    //   this.getdifficultleveltype=null;
    // });
  }, error => {  console.log(error) }
  );
  }

  gettesttypevalue:any;
  gettesttype()
  {
    this.ExamService.GetCode({'Tablename':"TESTING_PROBABILITY_TYPE"}).subscribe((i:any)=>{
      this.gettesttypevalue=i;
      console.log(this.gettesttypevalue);
    // }).catch((e:any)=>{
    //   this.getdifficultleveltype=null;
    // });
  }, error => {  console.log(error) }
  );
  }

  IncludeQuestioncheckbox(){
   if(this.selectedconceptlist.ExamInstanceConcept.Include_Questions_With_Images_Ind=='N')
   {
    this.selectedconceptlist.ExamInstanceConcept.Include_Questions_With_Images_Ind='Y';
   }
   else{
    this.selectedconceptlist.ExamInstanceConcept.Include_Questions_With_Images_Ind='N';
   }
  }

  LowerDifficultyLevelTypeCode(event:any){




    if(this.selectedconceptlist.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code!=null){
      if(Number(event)>Number(this.selectedconceptlist.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code)){

         this.toastr.warning('The Lower range cannot be higher the Upper range');
         this.LowerError=true;
         this.UpperError=false;
      }
      else{
        this.selectedconceptlist.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code=event;
        this.LowerError=false;
        this.UpperError=false;
      }
    }
    else{
      this.selectedconceptlist.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code=event;
      this.LowerError=false;
      this.UpperError=false;
    }
    // if(this.LowerError&&this.UpperError)
    // {

    // }
    // else if(this.UpperError){
    // this.UpperDifficultyLevelTypeCode(this.selectedconceptlist.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code);
    // }
  }
  UpperDifficultyLevelTypeCode(event:any){

    //this.selectedconceptlist.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code=event;


    if(this.selectedconceptlist.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code!=null){
      if(Number(event)<Number(this.selectedconceptlist.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code)){
        this.toastr.warning('The Upper range cannot be Lesser to the Lower range');
        this.UpperError=true;
        this.LowerError=false;
      }
      else{
        this.selectedconceptlist.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code=event;
        this.UpperError=false;
        this.LowerError=false;
      }
    }
    else{
      this.selectedconceptlist.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code=event;
      this.UpperError=false;
      this.LowerError=false;
    }
    // if(this.LowerError&&this.UpperError)
    // {

    // }
    // else if(this.LowerError){
    // this.LowerDifficultyLevelTypeCode(this.selectedconceptlist.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code);
    // }
  }
  MinimumNumberOfQuestions(event:any){
    //console.log(this.Refreshselectedconcept.ExamInstanceConcept)
    if(this.selectedconceptlist.ExamInstanceConcept.Maximum_Number_Of_Questions!=null){
    if(Number(event)>Number(this.selectedconceptlist.ExamInstanceConcept.Maximum_Number_Of_Questions)){

       this.toastr.warning('The Minimum cannot be higher  to the Maximum');
       this.MinimumError=true;
       this.MaximumError=false;

    }
    else{
    this.selectedconceptlist.ExamInstanceConcept.Minimum_Number_Of_Questions=event;
    this.MinimumError=false;
    this.MaximumError=false;
    }
  }
  else{
    this.selectedconceptlist.ExamInstanceConcept.Minimum_Number_Of_Questions=event;
    this.MinimumError=false;
    this.MaximumError=false;
  }
  // if(this.MinimumError&&this.MaximumError){

  // }
  // else if(this.MaximumError){
  // this.MaximumNumberOfQuestions(this.selectedconceptlist.ExamInstanceConcept.Maximum_Number_Of_Questions);
  // }
  }
  MaximumNumberOfQuestions(event:any){
    if(this.selectedconceptlist.ExamInstanceConcept.Minimum_Number_Of_Questions!=null){
    if(Number(event)<Number(this.selectedconceptlist.ExamInstanceConcept.Minimum_Number_Of_Questions)){
      this.toastr.warning('The Maximum cannot be lesser to the Minimum');
      this.MaximumError=true;
      this.MinimumError=false;
    }
    else{
    this.selectedconceptlist.ExamInstanceConcept.Maximum_Number_Of_Questions=event;
    this.MaximumError=false;
    this.MinimumError=false;

    }
  }
  else{
    this.selectedconceptlist.ExamInstanceConcept.Maximum_Number_Of_Questions=event;
    this.MaximumError=false;
    this.MinimumError=false;
  }
  // if(this.MinimumError&&this.MaximumError)
  // {

  // }
  // else if(this.MinimumError){
  // this.MinimumNumberOfQuestions(this.selectedconceptlist.ExamInstanceConcept.Minimum_Number_Of_Questions);
  // }
  }
  TestingProbabilityTypeCode(event:any){
    this.selectedconceptlist.ExamInstanceConcept.Testing_Probability_Type_Code=event;
  }

  selectedvalue:Number;
  selectedkey:string="";
  subjectID:any;
  count:Number;
  currentIDselected:Number;
  OnSelect(Value?:Number,d?:any,childnodeexist?:string){

  this.subjectID=Value;


    if(Value == null){
      return;
    }
    else if(Number(Value)>0){
    this.selectedvalue=Number(Value);
  this.selectedkey=d;}
    else{
      this.selectedvalue=0;
      this.selectedkey=d;}
  }

  selectedsubject:any;
  selectsubject(data:any){
    this.selectedsubject=data;
    this.getsubjectData(data,'MT',null)
  }

  subject:any;
  getsubjectData(data:any,name:any,M:any,C?:any,SC1?:any,SC2?:any,SC3?:any,SC4?:any,SC5?:any){
    let majortopicsarr:any=[];
    if(this.MajorTopic!=null){
    majortopicsarr=this.MajorTopic;
    }
    this.getsubjectId(data);
    let ID:Number=0;
    if(data !=null){ID=Number(data);}
    let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'EXAM INSTANCE';
      list["childRecordStatus"] = 'ALL';
      list["CalledFrom"] = 'EXAM';

    this.service.getSubjectTree(list).subscribe((i:any)=>{

      if(name == 'MT'){
        this.MajorTopic=i;
        for(let s of this.MajorTopic){
          let list: any = {};
          list["Exam_Instance_ID"] = this.ExamService.ExamInstanceID,
          list["Subject_Id"] = s.ID,
          list["Exam_Instance_Concept_ID"] = null,
          list["Lower_Difficulty_Level_Type_Code"] =null,
          list["Upper_Difficulty_Level_Type_Code"] =null,
          list["Include_Questions_With_Images_Ind"] ='N',
          list["Minimum_Number_Of_Questions"] =null,
          list["Maximum_Number_Of_Questions"] =null,
          list["Testing_Probability_Type_Code"]=null,
          list["Deleted_Ind"]='N'
          s.ExamInstanceConcept=list;
        }
        this.MajorTopic.map((obj: {
         checkedflag: boolean; })=>{
          obj.checkedflag = false;
          return obj;
        })
        this.ExamService.getExamInstanceConcept({LoggedInUser:this.session.getUser(),CourseID:this.ExamService.ExamInstanceID,CourseConceptID:this.ExamService.ExamConceptID,SubjectId:this.ExamService.ExamSubjectID}).subscribe(
          res => {
            this.response4=res;
            this.ExamInstanceConcept=this.response4.Data;
            for(let s of this.MajorTopic){
              for(let i of this.ExamInstanceConcept){
                 if(s.ID==i.Subject_Id)
                 {
                   s.checkedflag=true;
                   s.ExamInstanceConcept=i;
                 }

            }
            }
            console.log(this.MajorTopic,'test majottopic');
           },
          error => {
            console.log(error)
          }
        )




      }
      else if(name == 'C'){
        if(M!=null){
        if(this.MajorTopic[M].Data !== null && this.MajorTopic[M].Data!=='undefined')
        {

        this.MajorTopic[M].Data.map((obj: {
          checkedflag: boolean; })=>{
           obj.checkedflag = false;
           return obj;
         })
        }
        if(this.MajorTopic[M].Data !== null && this.MajorTopic[M].Data!=='undefined'){
        this.MajorTopic[M].Data=null;
        }
        else{
          this.MajorTopic[M].Data=i;
          this.MajorTopic[M].Data.map((obj: {
            ExamInstanceConcept: {};
            checkedflag: boolean; })=>{
             obj.checkedflag = false;
             obj.ExamInstanceConcept={};
             return obj;
           })
          for(let s of this.MajorTopic[M].Data){
            let list: any = {};
            list["Exam_Instance_ID"] = this.ExamService.ExamInstanceID,
            list["Subject_Id"] = s.ID,
            list["Exam_Instance_Concept_ID"] = null,
            list["Lower_Difficulty_Level_Type_Code"] =null,
            list["Upper_Difficulty_Level_Type_Code"] =null,
            list["Include_Questions_With_Images_Ind"] ='N',
            list["Minimum_Number_Of_Questions"] =null,
            list["Maximum_Number_Of_Questions"] =null,
            list["Testing_Probability_Type_Code"]=null,
            list["Deleted_Ind"]='N'
            s.ExamInstanceConcept=list;
          }

          this.ExamService.getExamInstanceConcept({LoggedInUser:this.session.getUser(),CourseID:this.ExamService.ExamInstanceID,CourseConceptID:this.ExamService.ExamConceptID,SubjectId:this.ExamService.ExamSubjectID}).subscribe(
            res => {
              this.response4=res;
              this.ExamInstanceConcept=this.response4.Data;
              for(let s of this.MajorTopic[M].Data){
                for(let i of this.ExamInstanceConcept){
                   if(s.ID==i.Subject_Id)
                   {
                     s.checkedflag=true;
                     s.ExamInstanceConcept=i;
                   }

              }
              }
              console.log(this.MajorTopic,'test majottopic');
             },
            error => {
              console.log(error)
            }
          )
        }
      }


      }
      else if(name == 'SC1'){

        if(M!=null&&C!=null){
        if(this.MajorTopic[M].Data[C].Data !== null && this.MajorTopic[M].Data[C].Data!=='undefined')
        {
        this.MajorTopic[M].Data[C].Data.map((obj: {
          checkedflag: boolean; })=>{
           obj.checkedflag = false;
           return obj;
         })
        }
        if(this.MajorTopic[M].Data[C].Data !== null && this.MajorTopic[M].Data[C].Data!=='undefined')
        this.MajorTopic[M].Data[C].Data=null;
        else{
        this.MajorTopic[M].Data[C].Data=i;
        this.MajorTopic[M].Data[C].Data.map((obj: {
          ExamInstanceConcept: {};
          checkedflag: boolean; })=>{
           obj.checkedflag = false;
           obj.ExamInstanceConcept={};
           return obj;
         })
        for(let s of this.MajorTopic[M].Data[C].Data){
          let list: any = {};
          list["Exam_Instance_ID"] = this.ExamService.ExamInstanceID,
          list["Subject_Id"] = s.ID,
          list["Exam_Instance_Concept_ID"] = null,
          list["Lower_Difficulty_Level_Type_Code"] =null,
          list["Upper_Difficulty_Level_Type_Code"] =null,
          list["Include_Questions_With_Images_Ind"] ='N',
          list["Minimum_Number_Of_Questions"] =null,
          list["Maximum_Number_Of_Questions"] =null,
          list["Testing_Probability_Type_Code"]=null,
          list["Deleted_Ind"]='N'
          s.ExamInstanceConcept=list;
        }
        this.ExamService.getExamInstanceConcept({LoggedInUser:this.session.getUser(),CourseID:this.ExamService.ExamInstanceID,CourseConceptID:this.ExamService.ExamConceptID,SubjectId:this.ExamService.ExamSubjectID}).subscribe(
          res => {
            this.response4=res;
            this.ExamInstanceConcept=this.response4.Data;
            for(let s of this.MajorTopic[M].Data[C].Data){
              for(let i of this.ExamInstanceConcept){
                 if(s.ID==i.Subject_Id)
                 {
                   s.checkedflag=true;
                   s.ExamInstanceConcept=i;
                 }

            }
            }
            console.log(this.MajorTopic,'test majottopic');
           },
          error => {
            console.log(error)
          }
        )

        }


      }
      }
      else if(name == 'SC2'){
        if(M!=null&&C!=null&&SC1!=null){
        if(this.MajorTopic[M].Data[C].Data[SC1].Data !== null && this.MajorTopic[M].Data[C].Data[SC1].Data!=='undefined')
        {
        this.MajorTopic[M].Data[C].Data[SC1].Data.map((obj: {
          checkedflag: boolean; })=>{
           obj.checkedflag = false;
           return obj;
         })
        }
        if(this.MajorTopic[M].Data[C].Data[SC1].Data !== null&&this.MajorTopic[M].Data[C].Data[SC1].Data !== 'undefined')
        this.MajorTopic[M].Data[C].Data[SC1].Data=null;
        else{
        this.MajorTopic[M].Data[C].Data[SC1].Data=i;
        this.MajorTopic[M].Data[C].Data[SC1].Data.map((obj: {
          ExamInstanceConcept: {};
          checkedflag: boolean; })=>{
           obj.checkedflag = false;
           obj.ExamInstanceConcept={};
           return obj;
         })
        for(let s of this.MajorTopic[M].Data[C].Data[SC1].Data){
          let list: any = {};
          list["Exam_Instance_ID"] = this.ExamService.ExamInstanceID,
          list["Subject_Id"] = s.ID,
          list["Exam_Instance_Concept_ID"] = null,
          list["Lower_Difficulty_Level_Type_Code"] =null,
          list["Upper_Difficulty_Level_Type_Code"] =null,
          list["Include_Questions_With_Images_Ind"] ='N',
          list["Minimum_Number_Of_Questions"] =null,
          list["Maximum_Number_Of_Questions"] =null,
          list["Testing_Probability_Type_Code"]=null,
          list["Deleted_Ind"]='N'
          s.ExamInstanceConcept=list;
        }
        this.ExamService.getExamInstanceConcept({LoggedInUser:this.session.getUser(),CourseID:this.ExamService.ExamInstanceID,CourseConceptID:this.ExamService.ExamConceptID,SubjectId:this.ExamService.ExamSubjectID}).subscribe(
          res => {
            this.response4=res;
            this.ExamInstanceConcept=this.response4.Data;
            for(let s of this.MajorTopic[M].Data[C].Data[SC1].Data){
              for(let i of this.ExamInstanceConcept){
                 if(s.ID==i.Subject_Id)
                 {
                   s.checkedflag=true;
                   s.ExamInstanceConcept=i;
                 }

            }
            }
            console.log(this.MajorTopic,'test majottopic');
           },
          error => {
            console.log(error)
          }
        )

        }


      }
      }
      else if(name == 'SC3'){
        if(M!=null&&C!=null&&SC1!=null&&SC2!=null){
        if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data !== null&&this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data!='undefined')
        {
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data.map((obj: {
          checkedflag: boolean; })=>{
           obj.checkedflag = false;
           return obj;
         })
        }
        if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data !== null&&this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data!='undefined')
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data=null;
        else{
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data=i;

        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data.map((obj: {
          ExamInstanceConcept: {};
          checkedflag: boolean; })=>{
           obj.checkedflag = false;
           obj.ExamInstanceConcept={};
           return obj;
         });
         for(let s of this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data){
          let list: any = {};
          list["Exam_Instance_ID"] = this.ExamService.ExamInstanceID,
          list["Subject_Id"] = s.ID,
          list["Exam_Instance_Concept_ID"] = null,
          list["Lower_Difficulty_Level_Type_Code"] =null,
          list["Upper_Difficulty_Level_Type_Code"] =null,
          list["Include_Questions_With_Images_Ind"] ='N',
          list["Minimum_Number_Of_Questions"] =null,
          list["Maximum_Number_Of_Questions"] =null,
          list["Testing_Probability_Type_Code"]=null,
          list["Deleted_Ind"]='N'
          s.ExamInstanceConcept=list;
        }
        this.ExamService.getExamInstanceConcept({LoggedInUser:this.session.getUser(),CourseID:this.ExamService.ExamInstanceID,CourseConceptID:this.ExamService.ExamConceptID,SubjectId:this.ExamService.ExamSubjectID}).subscribe(
          res => {
            this.response4=res;
            this.ExamInstanceConcept=this.response4.Data;
            for(let s of this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data){
              for(let i of this.ExamInstanceConcept){
                 if(s.ID==i.Subject_Id)
                 {
                   s.checkedflag=true;
                   s.ExamInstanceConcept=i;
                 }

            }
            }
            console.log(this.MajorTopic,'test majottopic');
           },
          error => {
            console.log(error)
          }
        )

        }
        }
      }
      else if(name == 'SC4'){
        if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data !== null&&this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data!='undefined')
        {
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data.map((obj: {
          checkedflag: boolean; })=>{
           obj.checkedflag = false;
           return obj;
         })
        }

        if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data !== null && this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data!='undife')
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data=null;
        else{
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data=i;

        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data.map((obj: {
          ExamInstanceConcept: {};
          checkedflag: boolean; })=>{
           obj.checkedflag = false;
           obj.ExamInstanceConcept={};
           return obj;
         });

         for(let s of this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data){
          let list: any = {};
          list["Exam_Instance_ID"] = this.ExamService.ExamInstanceID,
          list["Subject_Id"] = s.ID,
          list["Exam_Instance_Concept_ID"] = null,
          list["Lower_Difficulty_Level_Type_Code"] =null,
          list["Upper_Difficulty_Level_Type_Code"] =null,
          list["Include_Questions_With_Images_Ind"] ='N',
          list["Minimum_Number_Of_Questions"] =null,
          list["Maximum_Number_Of_Questions"] =null,
          list["Testing_Probability_Type_Code"]=null,
          list["Deleted_Ind"]='N'
          s.ExamInstanceConcept=list;
        }
        this.ExamService.getExamInstanceConcept({LoggedInUser:this.session.getUser(),CourseID:this.ExamService.ExamInstanceID,CourseConceptID:this.ExamService.ExamConceptID,SubjectId:this.ExamService.ExamSubjectID}).subscribe(
          res => {
            this.response4=res;
            this.ExamInstanceConcept=this.response4.Data;
            for(let s of this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data){
              for(let i of this.ExamInstanceConcept){
                 if(s.ID==i.Subject_Id)
                 {
                   s.checkedflag=true;
                   s.ExamInstanceConcept=i;
                 }

            }
            }
            console.log(this.MajorTopic,'test majottopic');
           },
          error => {
            console.log(error)
          }
        )
        }


      }
      else if(name == 'SC5'){
        if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data !== null && this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data !== null)
        {
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data.map((obj: {
          checkedflag: boolean; })=>{
           obj.checkedflag = false;
           return obj;
         })
        }
        if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data !== null &&this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data !== 'undefined')
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data=null;
        else{
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data=i;

        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data.map((obj: {
          ExamInstanceConcept: {};
          checkedflag: boolean; })=>{
           obj.checkedflag = false;
           obj.ExamInstanceConcept={};
           return obj;
         });

        for(let s of this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data){
          let list: any = {};
          list["Exam_Instance_ID"] = this.ExamService.ExamInstanceID,
          list["Subject_Id"] = s.ID,
          list["Exam_Instance_Concept_ID"] = null,
          list["Lower_Difficulty_Level_Type_Code"] =null,
          list["Upper_Difficulty_Level_Type_Code"] =null,
          list["Include_Questions_With_Images_Ind"] ='N',
          list["Minimum_Number_Of_Questions"] =null,
          list["Maximum_Number_Of_Questions"] =null,
          list["Testing_Probability_Type_Code"]=null,
          list["Deleted_Ind"]='N'
          s.ExamInstanceConcept=list;
        }
        this.ExamService.getExamInstanceConcept({LoggedInUser:this.session.getUser(),CourseID:this.ExamService.ExamInstanceID,CourseConceptID:this.ExamService.ExamConceptID,SubjectId:this.ExamService.ExamSubjectID}).subscribe(
          res => {
            this.response4=res;
            this.ExamInstanceConcept=this.response4.Data;
            for(let s of this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data){
              for(let i of this.ExamInstanceConcept){
                 if(s.ID==i.Subject_Id)
                 {
                   s.checkedflag=true;
                   s.ExamInstanceConcept=i;
                 }

            }
            }
            console.log(this.MajorTopic,'test majottopic');
           },
          error => {
            console.log(error)
          }
        )
      }

      }
      else if(name == 'SC6'){
        if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data !== null&&this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data !== 'undefined')
        {
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data.map((obj: {
          checkedflag: boolean; })=>{
           obj.checkedflag = false;
           return obj;
         })
        }
        if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data !== null)
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data=null;
        else{
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data=i;

        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data.map((obj: {
          ExamInstanceConcept: {};
          checkedflag: boolean; })=>{
           obj.checkedflag = false;
           obj.ExamInstanceConcept={};
           return obj;
         });

         for(let s of this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data){
          let list: any = {};
          list["Exam_Instance_ID"] = this.ExamService.ExamInstanceID,
          list["Subject_Id"] = s.ID,
          list["Exam_Instance_Concept_ID"] = null,
          list["Lower_Difficulty_Level_Type_Code"] =null,
          list["Upper_Difficulty_Level_Type_Code"] =null,
          list["Include_Questions_With_Images_Ind"] ='N',
          list["Minimum_Number_Of_Questions"] =null,
          list["Maximum_Number_Of_Questions"] =null,
          list["Testing_Probability_Type_Code"]=null,
          list["Deleted_Ind"]='N'
          s.ExamInstanceConcept=list;
        }
        this.ExamService.getExamInstanceConcept({
          LoggedInUser: this.session.getUser(),
          CourseID: this.ExamService.ExamInstanceID,
          CourseConceptID: this.ExamService.ExamConceptID,
          SubjectId: this.ExamService.ExamSubjectID,
        }).subscribe(
          (res) => {
            this.response4 = res;
            this.ExamInstanceConcept = this.response4.Data;
            for (let s of this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[
              SC3
            ].Data[SC4].Data[SC5].Data) {
              for (let i of this.ExamInstanceConcept) {
                if (s.ID == i.Subject_Id) {
                  s.checkedflag = true;
                  s.ExamInstanceConcept = i;
                }
              }
            }
            console.log(this.MajorTopic, 'test majottopic');
          },
          (error) => {
            console.log(error);
          }
        );
        }


      }
      console.log(this.MajorTopic,'check');

    //   }).catch((e:any)=>{
    //   this.subject=null;
    // }
    // )
  }, (error: any) => {  console.log(error) }
  );

  }

response:any;
  TracksubjectData(data:any,subjectid:any,finalsubject:any,name:any,M:any,C?:any,SC1?:any,SC2?:any,SC3?:any,SC4?:any,SC5?:any){
    let majortopicsarr:any=[];
    if(this.MajorTopic!=null){
    majortopicsarr=this.MajorTopic;
    }
    //this.getsubjectId(data);
    let ID:Number=0;
    if(data !=null){ID=Number(data);}
    let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'SUBJECT BREAKDOWN';
      list["childRecordStatus"] = 'ALL';
      list["CalledFrom"] = 'EXAM';

    this.service.getSubjectTree(list).subscribe((i:any)=>{
      this.response=i;
      for(let i=0;i<this.ExamInstanceConcept.length;i++){
        if(this.ExamInstanceConcept[i].track[0].dataID){
      if(this.ExamInstanceConcept[i].track[0].name=='MT'){
      //   for(let s of this.MajorTopic){
      //     for(let i of this.ExamInstanceConcept){
      //     if(s.ID==i.Subject_Id){
      //     {
      //       s.checkedflag=true;
      //       s.ExamInstanceConcept=i;
      //     }
      //   }
      //   }
      // }
      this.getsubjectData(this.ExamInstanceConcept[i].track[0].dataID,
        this.ExamInstanceConcept[i].track[0].name,
        this.ExamInstanceConcept[i].track[0].M,
        this.ExamInstanceConcept[i].track[0].C,
        this.ExamInstanceConcept[i].track[0].SC1,
        this.ExamInstanceConcept[i].track[0].SC2,
        this.ExamInstanceConcept[i].track[0].SC3,
        this.ExamInstanceConcept[i].track[0].SC4,
        this.ExamInstanceConcept[i].track[0].SC5)
      }
      else if(this.ExamInstanceConcept[i].track[0].name=='C')
      {
        this.getsubjectData(this.ExamInstanceConcept[i].track[0].dataID,
          this.ExamInstanceConcept[i].track[0].name,
          this.ExamInstanceConcept[i].track[0].M,
          this.ExamInstanceConcept[i].track[0].C,
          this.ExamInstanceConcept[i].track[0].SC1,
          this.ExamInstanceConcept[i].track[0].SC2,
          this.ExamInstanceConcept[i].track[0].SC3,
          this.ExamInstanceConcept[i].track[0].SC4,
          this.ExamInstanceConcept[i].track[0].SC5)
      }
      else if(this.ExamInstanceConcept[i].track[0].name=='SC1')
      {
        this.getsubjectData(this.ExamInstanceConcept[i].track[0].dataID,
          this.ExamInstanceConcept[i].track[0].name,
          this.ExamInstanceConcept[i].track[0].M,
          this.ExamInstanceConcept[i].track[0].C,
          this.ExamInstanceConcept[i].track[0].SC1,
          this.ExamInstanceConcept[i].track[0].SC2,
          this.ExamInstanceConcept[i].track[0].SC3,
          this.ExamInstanceConcept[i].track[0].SC4,
          this.ExamInstanceConcept[i].track[0].SC5)
      }
      else if(this.ExamInstanceConcept[i].track[0].name=='SC2')
      {
        this.getsubjectData(this.ExamInstanceConcept[i].track[0].dataID,
          this.ExamInstanceConcept[i].track[0].name,
          this.ExamInstanceConcept[i].track[0].M,
          this.ExamInstanceConcept[i].track[0].C,
          this.ExamInstanceConcept[i].track[0].SC1,
          this.ExamInstanceConcept[i].track[0].SC2,
          this.ExamInstanceConcept[i].track[0].SC3,
          this.ExamInstanceConcept[i].track[0].SC4,
          this.ExamInstanceConcept[i].track[0].SC5)
      }
    }



      }
      if(name == 'S'){
        for(let i=0;i<this.response.length;i++){
          if(this.response[i].ID==subjectid){
            for(let j=0;j<this.ExamInstanceConcept.length;j++)
             {
              if(this.ExamInstanceConcept[j].Subject_Id==finalsubject){
                this.ExamInstanceConcept[j].track[0].dataID=this.response[i].Parent_Id;
                this.ExamInstanceConcept[j].track[0].name='S';

                //this.getsubjectDataRefresh(this.ExamInstanceConcept[j].track[0]);
                //this.ExamInstanceConcept[j].track[0].M=i;
                //this.getsubjectData(this.ExamInstanceConcept[j].track[0].dataID,this.ExamInstanceConcept[j].track[0].name,null);

              }

             }
          }
        }
        console.log(this.MajorTopic,'MT');
      }
      else if(name == 'MT'){
        for(let i=0;i<this.response.length;i++){
          if(this.response[i].ID==subjectid){
            for(let j=0;j<this.ExamInstanceConcept.length;j++)
             {
              if(this.ExamInstanceConcept[j].Subject_Id==finalsubject){
                this.ExamInstanceConcept[j].track[0].dataID=this.response[i].Parent_Id;
                this.ExamInstanceConcept[j].track[0].name='MT';
                this.ExamInstanceConcept[j].track[0].M=i;

                //this.getsubjectData(this.ExamInstanceConcept[j].track[0].dataID,this.ExamInstanceConcept[j].track[0].name,this.ExamInstanceConcept[j].track[0].M);
                //this.getsubjectDataRefresh(this.ExamInstanceConcept[j].track[0]);

                console.log(this.MajorTopic,'MajorTopic MT');
              }

             }
          }
        }
        console.log(this.MajorTopic,'MT');
      }
      else if(name == 'C'){
        for(let i=0;i<this.response.length;i++){
          if(this.response[i].ID==subjectid){
            for(let j=0;j<this.ExamInstanceConcept.length;j++)
             {
              if(this.ExamInstanceConcept[j].Subject_Id==finalsubject){
                this.ExamInstanceConcept[j].track[0].dataID=this.response[i].Parent_Id;
                this.ExamInstanceConcept[j].track[0].name='C';
                this.ExamInstanceConcept[j].track[0].C=i;

                //this.getsubjectDataRefresh(this.ExamInstanceConcept[j].track[0]);
                //this.getsubjectData(this.ExamInstanceConcept[j].track[0].dataID,this.ExamInstanceConcept[j].track[0].name,this.ExamInstanceConcept[j].track[0].M,this.ExamInstanceConcept[j].track[0].C);
                console.log(this.MajorTopic,'MajorTopic C');
              }

             }
          }
        }
        console.log(this.MajorTopic,'C');

      }
      else if(name == 'SCL1'){
        for(let i=0;i<this.response.length;i++){
          if(this.response[i].ID==subjectid){
            for(let j=0;j<this.ExamInstanceConcept.length;j++)
             {
              if(this.ExamInstanceConcept[j].Subject_Id==finalsubject){
                this.ExamInstanceConcept[j].track[0].dataID=this.response[i].Parent_Id;
                this.ExamInstanceConcept[j].track[0].name='SC1';
                this.ExamInstanceConcept[j].track[0].SC1=i;

                //this.getsubjectDataRefresh(this.ExamInstanceConcept[j].track[0]);
                //this.getsubjectData(this.ExamInstanceConcept[j].track[0].dataID,this.ExamInstanceConcept[j].track[0].name,this.ExamInstanceConcept[j].track[0].M,this.ExamInstanceConcept[j].track[0].C,this.ExamInstanceConcept[j].track[0].SC1);
                console.log(this.MajorTopic,'MajorTopic SC1');
              }

             }
          }
        }
        console.log(this.MajorTopic,'C');
        console.log(this.MajorTopic,'SCL1');
      }
      else if(name == 'SCL2'){
        for(let i=0;i<this.response.length;i++){
          if(this.response[i].ID==subjectid){
            for(let j=0;j<this.ExamInstanceConcept.length;j++)
             {
              if(this.ExamInstanceConcept[j].Subject_Id==finalsubject){
                this.ExamInstanceConcept[j].track[0].dataID=this.response[i].Parent_Id;
                this.ExamInstanceConcept[j].track[0].name='SC2';
                this.ExamInstanceConcept[j].track[0].SC2=i;

                //this.getsubjectDataRefresh(this.ExamInstanceConcept[j].track[0]);
                //this.getsubjectData(this.ExamInstanceConcept[j].track[0].dataID,this.ExamInstanceConcept[j].track[0].name,this.ExamInstanceConcept[j].track[0].M,this.ExamInstanceConcept[j].track[0].C,this.ExamInstanceConcept[j].track[0].SC1);
                console.log(this.MajorTopic,'MajorTopic SC1');
              }

             }
          }
        }
        console.log(this.MajorTopic,'SCL2');
      }
      else if(name == 'SCL3'){
        for(let i=0;i<this.response.length;i++){
          if(this.response[i].ID==subjectid){
            for(let j=0;j<this.ExamInstanceConcept.length;j++)
             {
              if(this.ExamInstanceConcept[j].Subject_Id==finalsubject){
                this.ExamInstanceConcept[j].track[0].dataID=this.response[i].Parent_Id;
                this.ExamInstanceConcept[j].track[0].name='SC3';
                this.ExamInstanceConcept[j].track[0].SC3=i;

                //this.getsubjectDataRefresh(this.ExamInstanceConcept[j].track[0]);
                //this.getsubjectData(this.ExamInstanceConcept[j].track[0].dataID,this.ExamInstanceConcept[j].track[0].name,this.ExamInstanceConcept[j].track[0].M,this.ExamInstanceConcept[j].track[0].C,this.ExamInstanceConcept[j].track[0].SC1);
                console.log(this.MajorTopic,'MajorTopic SC1');
              }

             }
          }
        }
        console.log(this.MajorTopic,'SCL2');
        console.log(this.MajorTopic,'SCL3');
      }
      else if(name == 'SCL4'){
        for(let i=0;i<this.response.length;i++){
          if(this.response[i].ID==subjectid){
            for(let j=0;j<this.ExamInstanceConcept.length;j++)
             {
              if(this.ExamInstanceConcept[j].Subject_Id==finalsubject){
                this.ExamInstanceConcept[j].track[0].dataID=this.response[i].Parent_Id;
                this.ExamInstanceConcept[j].track[0].name='SC4';
                this.ExamInstanceConcept[j].track[0].SC4=i;

                //this.getsubjectDataRefresh(this.ExamInstanceConcept[j].track[0]);
                //this.getsubjectData(this.ExamInstanceConcept[j].track[0].dataID,this.ExamInstanceConcept[j].track[0].name,this.ExamInstanceConcept[j].track[0].M,this.ExamInstanceConcept[j].track[0].C,this.ExamInstanceConcept[j].track[0].SC1);
                console.log(this.MajorTopic,'MajorTopic SC1');
              }

             }
          }
        }
        console.log(this.MajorTopic,'SCL4');
      }
      else if(name == 'SCL5'){
        for(let i=0;i<this.response.length;i++){
          if(this.response[i].ID==subjectid){
            for(let j=0;j<this.ExamInstanceConcept.length;j++)
             {
              if(this.ExamInstanceConcept[j].Subject_Id==finalsubject){
                this.ExamInstanceConcept[j].track[0].dataID=this.response[i].Parent_Id;
                this.ExamInstanceConcept[j].track[0].name='SC5';
                this.ExamInstanceConcept[j].track[0].SC5=i;

                //this.getsubjectDataRefresh(this.ExamInstanceConcept[j].track[0]);
                //this.getsubjectData(this.ExamInstanceConcept[j].track[0].dataID,this.ExamInstanceConcept[j].track[0].name,this.ExamInstanceConcept[j].track[0].M,this.ExamInstanceConcept[j].track[0].C,this.ExamInstanceConcept[j].track[0].SC1);
                console.log(this.MajorTopic,'MajorTopic SC1');
              }

             }
          }
        }
        console.log(this.MajorTopic,'SCL5');
      }
      else if(name == 'SCL6'){
        for(let i=0;i<this.response.length;i++){
          if(this.response[i].ID==subjectid){
            for(let j=0;j<this.ExamInstanceConcept.length;j++)
             {
              if(this.ExamInstanceConcept[j].Subject_Id==finalsubject){
                this.ExamInstanceConcept[j].track[0].dataID=this.response[i].Parent_Id;
                this.ExamInstanceConcept[j].track[0].name='SC6';
                this.ExamInstanceConcept[j].track[0].SC6=i;

                //this.getsubjectDataRefresh(this.ExamInstanceConcept[j].track[0]);
                //this.getsubjectData(this.ExamInstanceConcept[j].track[0].dataID,this.ExamInstanceConcept[j].track[0].name,this.ExamInstanceConcept[j].track[0].M,this.ExamInstanceConcept[j].track[0].C,this.ExamInstanceConcept[j].track[0].SC1);
                console.log(this.MajorTopic,'MajorTopic SC1');
              }

             }
          }
        }
        console.log(this.MajorTopic,'SCL6');

      }

  }, (error: any) => {  console.log(error) }
  );


  }


  statusvalidate:any;
  DefaultStatus:any;
  subjectById:any;
  getsubjectId(data:any)
  {
     let ID:Number=0;
     try{
     if(data>0||data==null)
     {
      ID=Number(data);
     }
     else if(Number(data.ID)>0){
      ID=Number(data.ID);
     }
    }catch{
     }
     this.service.getsubjectById({'CurrentNodeSubjectID':Number(ID)}).subscribe((i:any)=>{
      this.subjectById=i;
      // if(this.AddQuestionflag){
      //   this.QuestionTemplateType();
      // }


    // }).catch((e:any)=>{
    //   this.subjectById=null;
    // }
    // )
  }, error => {  console.log(error) }
  );



  }

  refresh(data:any)
  {
    this.service.getBreadcrumbDetails({'ID':data}).subscribe((i:any)=>{
      this.Breadcrumblist=i;

      this.Breadcrumblist.forEach((element: { Subject_ID: any; Subject_Level_Type_Code: any; }) => {

        this.service.getsubjectById({'CurrentNodeSubjectID':Number(element.Subject_ID)}).subscribe((i:any)=>{

          this.subjectById1=i;
          this.TracksubjectData(this.subjectById1.Parent_Subject_Id,this.subjectById1.Subject_Id,data,this.subjectById1.Subject_Level_Type_Code,null)


      }, error => {  console.log(error) }
      );
      });


      console.log(this.Breadcrumblist);
    }, (error:any) => { console.log(error) }
    );

  }
  ExamInstanceConcept:any;
  response4:any;
  Breadcrumblist:any;
  Selectedlist:any[] = [];
  subjectById1:any;
  getExamInstanceConceptResponse(data:any){
    this.response4=data;
    this.ExamInstanceConcept=this.response4.Data;
//     if(this.ExamInstanceConcept.length>0){
//       this.ExamInstanceConcept.map((obj: {
//         track:any
// })=>{
//         obj.track = [];
//         return obj;
//       })
//     }
//     for(let i=0;i<this.ExamInstanceConcept.length;i++){
//       let list: any = {};
//       list["dataID"] = null
//       list["name"] = null,
//       list["M"]=null,
//       list["C"] = null,
//       list["SC1"] =null,
//       list["SC2"] =null,
//       list["SC3"] =null,
//       list["SC4"] =null,
//       list["SC5"] =null,
//       list["SC6"] =null
//       this.ExamInstanceConcept[i].track.push(list);
//     }

//     if(this.ExamInstanceConcept.length>0){

//       for(let i=0;i<this.ExamInstanceConcept.length;i++){
//          this.refresh(this.ExamInstanceConcept[i].Subject_Id);

//       }




//   }

  }
  subjectresponse:any;
  ExamInstanceConceptSubject:any;
  getExamInstanceConceptSubject(data:any){
    this.subjectresponse=data;
    this.ExamInstanceConceptSubject=this.subjectresponse.Data;
    console.log(this.ExamInstanceConceptSubject,'ExamInstanceConceptSubject')

    for(let i=0;i<this.ExamInstanceConceptSubject.length;i++){
      this.getBreadcrumbDetails(this.ExamInstanceConceptSubject[i].Subject_Id);
    }

  }

  trackinglist:any=[];
  trackinglistindex:any=[];
  getBreadcrumbDetails(data:any){
    this.service.getBreadcrumbDetails({'ID':data}).subscribe((i:any)=>{
      this.Breadcrumblist=i;

      if(this.Breadcrumblist.length>0){
        let tempListlet: any = {
          data:this.Breadcrumblist
        };
        this.trackinglist.push(tempListlet);
      }
      if(this.trackinglist.length==this.ExamInstanceConceptSubject.length){

         for(let j=0;j<this.trackinglist.length;j++){

          //  for(let k=0;k<this.trackinglist[j].data.length;k++){
          //      if(this.trackinglist[j].data[k])

          //  }

         }
      }


  }, (error:any) => { console.log(error) }
  );
  }
  MTflag:boolean=true;
  MTID:any;
  Cflag:boolean=true;
  SC1flag:boolean=true;
  SC2flag:boolean=true;
  SC3flag:boolean=true;
  SC4flag:boolean=true;
  SC5flag:boolean=true;
  SC6flag:boolean=true;
  static Refreshselectedconcept:any;
  checkbox(data:any,name:any,M:any,C?:any,SC1?:any,SC2?:any,SC3?:any,SC4?:any,SC5?:any,SC6?:any){


    if (name == 'C'){
      if(this.MajorTopic[M].Study_Unit_Ind=='Y')
      {
        this.MajorTopic[M].Study_Unit_Ind='N';
        this.DeleteConceptpopup(this.MajorTopic[M]);
      }
      else{
        this.MajorTopic[M].Study_Unit_Ind='Y';
        this.OpenAddEditConceptpopup(this.MajorTopic[M]);
      }

    }
    else if(name == 'SC1'){

      if(this.MajorTopic[M].Data[C].Study_Unit_Ind=='Y')
      {
        this.MajorTopic[M].Data[C].Study_Unit_Ind='N';
        this.DeleteConceptpopup(this.MajorTopic[M].Data[C]);
      }
      else{

        this.MajorTopic[M].Data[C].Study_Unit_Ind=='Y';
        this.OpenAddEditConceptpopup(this.MajorTopic[M].Data[C]);

      }
    }
    else if(name == 'SC2'){


      if(this.MajorTopic[M].Data[C].Data[SC1].Study_Unit_Ind=='Y')
      {
        this.MajorTopic[M].Data[C].Data[SC1].Study_Unit_Ind='N';
        this.DeleteConceptpopup(this.MajorTopic[M].Data[C].Data[SC1]);
      }
      else{
        this.MajorTopic[M].Data[C].Data[SC1].Study_Unit_Ind=='Y';
        this.OpenAddEditConceptpopup(this.MajorTopic[M].Data[C].Data[SC1]);


      }
    }
    else if(name == 'SC3'){

      if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Study_Unit_Ind=='Y')
      {
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Study_Unit_Ind='N';
        this.DeleteConceptpopup(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2]);
      }
      else{

        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Study_Unit_Ind='Y';
        this.OpenAddEditConceptpopup(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2]);

      }
    }
    else if(name == 'SC4'){


      if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Study_Unit_Ind=='Y')
      {
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Study_Unit_Ind='N';
        this.DeleteConceptpopup(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3]);
      }
      else{

        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Study_Unit_Ind='Y';
        this.OpenAddEditConceptpopup(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3]);

      }
    }
    else if(name == 'SC5'){
      if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Study_Unit_Ind=='Y')
      {
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Study_Unit_Ind='N';
        this.DeleteConceptpopup(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4]);
      }
      else{

        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Study_Unit_Ind='Y';
        this.OpenAddEditConceptpopup(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4]);

      }
    }
    else if(name == 'SC6'){

      if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Study_Unit_Ind=='Y')
      {
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Study_Unit_Ind='N';
        this.DeleteConceptpopup(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5]);
      }
      else{

        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Study_Unit_Ind='Y';
        this.OpenAddEditConceptpopup(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5]);

      }

    }
    else if(name == 'SC7'){

      if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data[SC6].Study_Unit_Ind=='Y')
      {
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data[SC6].Study_Unit_Ind='N';
        this.DeleteConceptpopup(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data[SC6]);
      }
      else{

        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data[SC6].Study_Unit_Ind='Y';
        this.OpenAddEditConceptpopup(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data[SC6]);

      }

    }

    }

    counter(i: number) {
      return new Array(i);
  }
  counter1(i: number) {
    return new Array(i);
}


//delete concept
deleteanswer:any;
DeleteConceptpopup(data:any){

  this.selectedconceptlist=data;

  this.DeleteConceptAlertpopup();
}
DeleteConceptAlertflag:boolean;
DeleteConceptAlertpopup(){
  this.DeleteConceptAlertflag=!this.DeleteConceptAlertflag;
}
CloseDeleteAlertpopup(){
  if(this.DeleteConceptAlertflag){
    this.DeleteConceptAlertpopup();
    this.ngOnInit();
  }
  this.MinimumError=false;
  this.MaximumError=false;
  this.UpperError=false;
  this.LowerError=false;
}
DeleteConcept(){
  //this.MajorTopic[M].checkedflag=false;
  this.selectedconceptlist.ExamInstanceConcept.Deleted_Ind='Y';
  this.Delete();
}

AddEditmodelpopupflag:boolean;
AddEditConceptmodelpopup(){
 this.AddEditmodelpopupflag=!this.AddEditmodelpopupflag;
}


CloseAddEditConceptModel(){
  if(this.AddEditmodelpopupflag){
    this.AddEditConceptmodelpopup();
    this.ngOnInit();
  }
  this.MinimumError=false;
  this.MaximumError=false;
  this.UpperError=false;
  this.LowerError=false;
}
Delete(){
  let UDTExamInstanceConcept: any[] = [];
  let list: any = {};
  list["Course_Id"] = this.selectedconceptlist.ExamInstanceConcept.Exam_Instance_ID,
  list["Subject_Id"] = this.selectedconceptlist.ExamInstanceConcept.Subject_Id,
  list["Course_Concept_Id"] = this.selectedconceptlist.ExamInstanceConcept.Exam_Instance_Concept_ID,
  list["Lower_Difficulty_Level_Type_Code"] =this.selectedconceptlist.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code,
  list["Upper_Difficulty_Level_Type_Code"] =this.selectedconceptlist.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code,
  list["Include_Questions_With_Images_Ind"] =this.selectedconceptlist.ExamInstanceConcept.Include_Questions_With_Images_Ind,
  list["Minimum_Number_Of_Questions"] =this.selectedconceptlist.ExamInstanceConcept.Minimum_Number_Of_Questions,
  list["Maximum_Number_Of_Questions"]=this.selectedconceptlist.ExamInstanceConcept.Maximum_Number_Of_Questions,
  list["Testing_Probability_Type_Code"]=this.selectedconceptlist.ExamInstanceConcept.Testing_Probability_Type_Code,
  list["Deleted_Ind"]=this.selectedconceptlist.ExamInstanceConcept.Deleted_Ind
  UDTExamInstanceConcept.push(list);
  let templist: any = {};
  templist["LoggedInUser"] = this.session.getUser();
  templist["sessionLanguageTypeCode"] = this.appserv.userlanuage;
  templist["UDTCourseConcept"] = UDTExamInstanceConcept;

  this.ExamService.createExamInstanceConcept(templist).subscribe(

    res => {
      this.getresponse=res;
      this.Insertresponse=this.getresponse
      if(this.Insertresponse.Message=='Success'){
         this.toastr.success('Success!');
         this.CloseDeleteAlertpopup();

      }
      else{
        this.toastr.error(this.Insertresponse.Message);
      }
    },
    error => {
      this.toastr.error(this.Insertresponse.Message);
    }
  )
}

getresponse:any;
Insertresponse:any;
Save(){

  let UDTExamInstanceConcept: any[] = [];
  let list: any = {};
  list["Course_Id"] = this.selectedconceptlist.ExamInstanceConcept.Exam_Instance_ID,
  list["Subject_Id"] = this.selectedconceptlist.ExamInstanceConcept.Subject_Id,
  list["Course_Subject_Id"] = this.selectedconceptlist.ExamInstanceConcept.Exam_Instance_Concept_ID,
  list["Lower_Difficulty_Level_Type_Code"] =this.selectedconceptlist.ExamInstanceConcept.Lower_Difficulty_Level_Type_Code,
  list["Upper_Difficulty_Level_Type_Code"] =this.selectedconceptlist.ExamInstanceConcept.Upper_Difficulty_Level_Type_Code,
  list["Include_Questions_With_Images_Ind"] =this.selectedconceptlist.ExamInstanceConcept.Include_Questions_With_Images_Ind,
  list["Minimum_Number_Of_Questions"] =this.selectedconceptlist.ExamInstanceConcept.Minimum_Number_Of_Questions,
  list["Maximum_Number_Of_Questions"]=this.selectedconceptlist.ExamInstanceConcept.Maximum_Number_Of_Questions,
  list["Testing_Probability_Type_Code"]=this.selectedconceptlist.ExamInstanceConcept.Testing_Probability_Type_Code,
  list["Deleted_Ind"]=this.selectedconceptlist.ExamInstanceConcept.Deleted_Ind
  UDTExamInstanceConcept.push(list);
  let templist: any = {};
  templist["LoggedInUser"] = this.session.getUser();
  templist["sessionLanguageTypeCode"] = this.appserv.userlanuage;
  templist["UDTCourseConcept"] = UDTExamInstanceConcept;

  this.ExamService.createExamInstanceConcept(templist).subscribe(

    res => {
      this.getresponse=res;
      this.Insertresponse=this.getresponse
      if(this.Insertresponse.Message=='Success'){
         this.toastr.success('Success!');
         this.CloseAddEditConceptModel();
         this.ngOnInit();
      }
      else{
        this.toastr.error(this.Insertresponse.Message);
      }
    },
    error => {
      this.toastr.error(this.Insertresponse.Message);
    }
  )

}



  }


interface MajorTopic{
  ChildNodeExistInd:string;
  Data: any;
  Display_Order: Number;
  ID: Number;
  Name: string;
  Parent_Id:Number;
  Status_Code: string;
  Subject_Level_Type_Code: string;
  checkedflag:boolean;
  ExamInstanceConcept:any;
  Exam_Instance_Concept_Exists_Ind:string;
  Study_Unit_Ind:string;
}




